import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import type { Role } from '@stromo/shared';

export interface UserLookup {
  id: number;
  abbreviation: string;
  first_name: string;
  last_name: string;
  role: Role;
}

export interface ContactLookup {
  id: number;
  name: string;
  contact_types: Array<'architect' | 'client' | 'gu' | 'other'>;
}

export interface TemplateLookup {
  id: number;
  name: string;
  description: string | null;
  version: number;
  is_active: boolean;
}

export function useUsersLookup() {
  return useQuery({
    queryKey: ['lookup', 'users'],
    queryFn: async () => {
      const { data } = await api.get<{ items: UserLookup[] }>('/lookups/users');
      return data.items;
    },
    staleTime: 5 * 60 * 1000,
  });
}

export function useContactsLookup(type?: ContactLookup['contact_types'][number]) {
  return useQuery({
    queryKey: ['lookup', 'contacts', type ?? 'all'],
    queryFn: async () => {
      const { data } = await api.get<{ items: ContactLookup[] }>('/lookups/contacts', {
        params: type ? { type } : undefined,
      });
      return data.items;
    },
    staleTime: 5 * 60 * 1000,
  });
}

export function useTemplatesLookup() {
  return useQuery({
    queryKey: ['lookup', 'templates'],
    queryFn: async () => {
      const { data } = await api.get<{ items: TemplateLookup[] }>('/lookups/templates');
      return data.items;
    },
    staleTime: 5 * 60 * 1000,
  });
}
